import $ from 'jquery';

document.addEventListener('Neos.PageLoaded', () => {
  $('.neos-tooltip').remove();
}, false);